// import { useEffect } from "react";

// export default function SEO({
//   title,
//   description,
//   canonical,
//   image
// }) {
//   useEffect(() => {
//     /* ================= TITLE ================= */
//     if (title) {
//       document.title = `${title}`;
//     }

//     /* ================= META DESCRIPTION ================= */
//     if (description) {
//       let metaDescription = document.querySelector("meta[name='description']");
//       if (!metaDescription) {
//         metaDescription = document.createElement("meta");
//         metaDescription.name = "description";
//         document.head.appendChild(metaDescription);
//       }
//       metaDescription.setAttribute("content", description);
//     }

//     /* ================= ROBOTS ================= */
//     let robots = document.querySelector("meta[name='robots']");
//     if (!robots) {
//       robots = document.createElement("meta");
//       robots.name = "robots";
//       document.head.appendChild(robots);
//     }
//     robots.setAttribute("content", "index, follow");

//     /* ================= CANONICAL ================= */
//     if (canonical) {
//       let link = document.querySelector("link[rel='canonical']");
//       if (!link) {
//         link = document.createElement("link");
//         link.rel = "canonical";
//         document.head.appendChild(link);
//       }
//       link.href = canonical;
//     }

//     /* ================= OPEN GRAPH ================= */
//     const setMeta = (property, content) => {
//       if (!content) return;
//       let meta = document.querySelector(`meta[property='${property}']`);
//       if (!meta) {
//         meta = document.createElement("meta");
//         meta.setAttribute("property", property);
//         document.head.appendChild(meta);
//       }
//       meta.setAttribute("content", content);
//     };

//     setMeta("og:title", title);
//     setMeta("og:description", description);
//     setMeta("og:type", "website");
//     setMeta("og:url", canonical);
//     setMeta("og:image", image);

//     /* ================= TWITTER ================= */
//     const setTwitter = (name, content) => {
//       if (!content) return;
//       let meta = document.querySelector(`meta[name='${name}']`);
//       if (!meta) {
//         meta = document.createElement("meta");
//         meta.name = name;
//         document.head.appendChild(meta);
//       }
//       meta.setAttribute("content", content);
//     };

//     setTwitter("twitter:card", "summary_large_image");
//     setTwitter("twitter:title", title);
//     setTwitter("twitter:description", description);
//     setTwitter("twitter:image", image);

//     /* ================= ORGANIZATION SCHEMA ================= */
//     let schema = document.getElementById("org-schema");
//     if (!schema) {
//       schema = document.createElement("script");
//       schema.type = "application/ld+json";
//       schema.id = "org-schema";
//       document.head.appendChild(schema);
//     }

//     schema.textContent = JSON.stringify({
//       "@context": "https://schema.org",
//       "@type": "Organization",
//       name: "TechArticleHub",
//       url: "https://techarticlehub.com",
//       logo: "https://techarticlehub.com/logo.png",
//       sameAs: [
//         "https://www.facebook.com/techarticlehub",
//         "https://twitter.com/techarticlehub",
//         "https://www.linkedin.com/company/techarticlehub"
//       ]
//     });

//   }, [title, description, canonical, image]);

//   return null;
// }


import { useEffect } from "react";

export default function SEO({
  title,
  description,
  canonical,
  image,
  article,   // 👈 NEW
  author     // 👈 NEW
}) {
  useEffect(() => {
    /* ================= TITLE ================= */
    if (title) {
      document.title = title;
    }

    /* ================= META DESCRIPTION ================= */
    if (description) {
      let metaDescription = document.querySelector("meta[name='description']");
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute("content", description);
    }

    /* ================= ROBOTS ================= */
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index, follow");

    /* ================= CANONICAL ================= */
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    /* ================= OPEN GRAPH ================= */
    const setMeta = (property, content) => {
      if (!content) return;
      let meta = document.querySelector(`meta[property='${property}']`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("property", property);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    const isArticle = Boolean(article?.slug);

    setMeta("og:title", title);
    setMeta("og:description", description);
    setMeta("og:type", isArticle ? "article" : "website");
    setMeta("og:url", canonical);
    setMeta("og:image", image);

    /* ================= TWITTER ================= */
    const setTwitter = (name, content) => {
      if (!content) return;
      let meta = document.querySelector(`meta[name='${name}']`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setTwitter("twitter:card", "summary_large_image");
    setTwitter("twitter:title", title);
    setTwitter("twitter:description", description);
    setTwitter("twitter:image", image);

    /* ================= ORGANIZATION SCHEMA (GLOBAL) ================= */
    let orgSchema = document.getElementById("org-schema");
    if (!orgSchema) {
      orgSchema = document.createElement("script");
      orgSchema.type = "application/ld+json";
      orgSchema.id = "org-schema";
      document.head.appendChild(orgSchema);
    }

    orgSchema.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "TechArticleHub",
      url: "https://techarticlehub.com",
      logo: "https://techarticlehub.com/logo.png",
      sameAs: [
        "https://www.facebook.com/techarticlehub",
        "https://twitter.com/techarticlehub",
        "https://www.linkedin.com/company/techarticlehub"
      ]
    });

    /* ================= ARTICLE SCHEMA (ONLY ON ARTICLE PAGE) ================= */
    if (isArticle) {
      let articleSchema = document.getElementById("article-schema");
      if (!articleSchema) {
        articleSchema = document.createElement("script");
        articleSchema.type = "application/ld+json";
        articleSchema.id = "article-schema";
        document.head.appendChild(articleSchema);
      }

      articleSchema.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title,
        description: article.meta_description || article.excerpt,
        image: article.images ? [article.images] : undefined,
        datePublished: article.created_at,
        dateModified: article.updated_at || article.created_at,
        author: {
          "@type": "Person",
          name: author?.name || "Naveen Kumar",
          url: `https://techarticlehub.com/author/${author?.slug || "naveen-kumar"}`
        },
        publisher: {
          "@type": "Organization",
          name: "TechArticleHub",
          logo: {
            "@type": "ImageObject",
            url: "https://techarticlehub.com/logo.png"
          }
        },
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": canonical
        }
      });
    }

  }, [title, description, canonical, image, article, author]);

  return null;
}
